import moda_1 from "./../../assets/images/proyectos/moda/moda_1.jpg";
import moda_2 from "./../../assets/images/proyectos/moda/moda_2.jpg";
import moda_3 from "./../../assets/images/proyectos/moda/moda_3.jpg";
import moda_4 from "./../../assets/images/proyectos/moda/moda_4.jpg";
import moda_5 from "./../../assets/images/proyectos/moda/moda_5.jpg";
import moda_6 from "./../../assets/images/proyectos/moda/moda_6.jpg";
import moda_7 from "./../../assets/images/proyectos/moda/moda_7.jpg";
import moda_8 from "./../../assets/images/proyectos/moda/moda_8.jpg";
import moda_9 from "./../../assets/images/proyectos/moda/moda_9.jpg";
import moda_10 from "./../../assets/images/proyectos/moda/moda_10.jpg";
import moda_11 from "./../../assets/images/proyectos/moda/moda_11.jpg";
import moda_12 from "./../../assets/images/proyectos/moda/moda_12.jpg";
import moda_13 from "./../../assets/images/proyectos/moda/moda_13.jpg";
import moda_14 from "./../../assets/images/proyectos/moda/moda_14.jpg";
import moda_15 from "./../../assets/images/proyectos/moda/moda_15.jpg";
import moda_16 from "./../../assets/images/proyectos/moda/moda_16.jpg";
import moda_17 from "./../../assets/images/proyectos/moda/moda_17.jpg";
import moda_18 from "./../../assets/images/proyectos/moda/moda_18.jpg";
import moda_19 from "./../../assets/images/proyectos/moda/moda_19.jpg";
import moda_20 from "./../../assets/images/proyectos/moda/moda_20.jpg";
import moda_21 from "./../../assets/images/proyectos/moda/moda_21.jpg";
import moda_22 from "./../../assets/images/proyectos/moda/moda_22.jpg";
import moda_23 from "./../../assets/images/proyectos/moda/moda_23.jpg";
import moda_24 from "./../../assets/images/proyectos/moda/moda_24.jpg";
import moda_25 from "./../../assets/images/proyectos/moda/moda_25.jpg";
import moda_26 from "./../../assets/images/proyectos/moda/moda_26.jpg";
import moda_27 from "./../../assets/images/proyectos/moda/moda_27.jpg";
import moda_28 from "./../../assets/images/proyectos/moda/moda_28.jpg";
import moda_29 from "./../../assets/images/proyectos/moda/moda_29.jpg";
import moda_30 from "./../../assets/images/proyectos/moda/moda_30.jpg";
import moda_31 from "./../../assets/images/proyectos/moda/moda_31.jpg";
import moda_32 from "./../../assets/images/proyectos/moda/moda_32.jpg";
import moda_33 from "./../../assets/images/proyectos/moda/moda_33.jpg";
import moda_34 from "./../../assets/images/proyectos/moda/moda_34.jpg";
import moda_35 from "./../../assets/images/proyectos/moda/moda_35.jpg";
import moda_36 from "./../../assets/images/proyectos/moda/moda_36.jpg";
import moda_37 from "./../../assets/images/proyectos/moda/moda_37.jpg";
import moda_38 from "./../../assets/images/proyectos/moda/moda_38.jpg";
import moda_39 from "./../../assets/images/proyectos/moda/moda_39.jpg";
import moda_40 from "./../../assets/images/proyectos/moda/moda_40.jpg";
import moda_41 from "./../../assets/images/proyectos/moda/moda_41.jpg";
import moda_42 from "./../../assets/images/proyectos/moda/moda_42.jpg";
import moda_43 from "./../../assets/images/proyectos/moda/moda_43.jpg";
import moda_44 from "./../../assets/images/proyectos/moda/moda_44.jpg";
import moda_45 from "./../../assets/images/proyectos/moda/moda_45.jpg";
import moda_46 from "./../../assets/images/proyectos/moda/moda_46.jpg";
import moda_47 from "./../../assets/images/proyectos/moda/moda_47.jpg";
import moda_48 from "./../../assets/images/proyectos/moda/moda_48.jpg";
import moda_49 from "./../../assets/images/proyectos/moda/moda_49.jpg";
import moda_50 from "./../../assets/images/proyectos/moda/moda_50.jpg";
import moda_51 from "./../../assets/images/proyectos/moda/moda_51.jpg";
import moda_52 from "./../../assets/images/proyectos/moda/moda_52.jpg";
import moda_53 from "./../../assets/images/proyectos/moda/moda_53.jpg";
import moda_54 from "./../../assets/images/proyectos/moda/moda_54.jpg";
import moda_55 from "./../../assets/images/proyectos/moda/moda_55.jpg";
import moda_56 from "./../../assets/images/proyectos/moda/moda_56.jpg";
import moda_57 from "./../../assets/images/proyectos/moda/moda_57.jpg";
import moda_58 from "./../../assets/images/proyectos/moda/moda_58.jpg";
import moda_59 from "./../../assets/images/proyectos/moda/moda_59.jpg";
import moda_60 from "./../../assets/images/proyectos/moda/moda_60.jpg";
import moda_61 from "./../../assets/images/proyectos/moda/moda_61.jpg";
import moda_62 from "./../../assets/images/proyectos/moda/moda_62.jpg";
import moda_63 from "./../../assets/images/proyectos/moda/moda_63.jpg";
import moda_64 from "./../../assets/images/proyectos/moda/moda_64.jpg";
import moda_65 from "./../../assets/images/proyectos/moda/moda_65.jpg";
import moda_66 from "./../../assets/images/proyectos/moda/moda_66.jpg";
import moda_67 from "./../../assets/images/proyectos/moda/moda_67.jpg";
import moda_68 from "./../../assets/images/proyectos/moda/moda_68.jpg";
import moda_69 from "./../../assets/images/proyectos/moda/moda_69.jpg";
import moda_70 from "./../../assets/images/proyectos/moda/moda_70.jpg";
import moda_71 from "./../../assets/images/proyectos/moda/moda_71.jpg";
import moda_72 from "./../../assets/images/proyectos/moda/moda_72.jpg";
import moda_73 from "./../../assets/images/proyectos/moda/moda_73.jpg";
import moda_74 from "./../../assets/images/proyectos/moda/moda_74.jpg";
import moda_75 from "./../../assets/images/proyectos/moda/moda_75.jpg";
import moda_76 from "./../../assets/images/proyectos/moda/moda_76.jpg";
import moda_77 from "./../../assets/images/proyectos/moda/moda_77.jpg";
import moda_78 from "./../../assets/images/proyectos/moda/moda_78.jpg";
import moda_79 from "./../../assets/images/proyectos/moda/moda_79.jpg";


import retrato_1 from "./../../assets/images/proyectos/retratos/retratos_1.jpg";
import retrato_2 from "./../../assets/images/proyectos/retratos/retratos_2.jpg";
import retrato_3 from "./../../assets/images/proyectos/retratos/retratos_3.jpg";
import retrato_4 from "./../../assets/images/proyectos/retratos/retratos_4.jpg";
import retrato_5 from "./../../assets/images/proyectos/retratos/retratos_5.jpg";
import retrato_6 from "./../../assets/images/proyectos/retratos/retratos_6.jpg";
import retrato_7 from "./../../assets/images/proyectos/retratos/retratos_7.jpg";
import retrato_8 from "./../../assets/images/proyectos/retratos/retratos_8.jpg";
import retrato_9 from "./../../assets/images/proyectos/retratos/retratos_9.jpg";
import retrato_10 from "./../../assets/images/proyectos/retratos/retratos_10.jpg";
import retrato_11 from "./../../assets/images/proyectos/retratos/retratos_11.jpg";
import retrato_12 from "./../../assets/images/proyectos/retratos/retratos_12.jpg";
import retrato_13 from "./../../assets/images/proyectos/retratos/retratos_13.jpg";
import retrato_14 from "./../../assets/images/proyectos/retratos/retratos_14.jpg";
import retrato_15 from "./../../assets/images/proyectos/retratos/retratos_15.jpg";
import retrato_16 from "./../../assets/images/proyectos/retratos/retratos_16.jpg";
import retrato_17 from "./../../assets/images/proyectos/retratos/retratos_17.jpg";
import retrato_18 from "./../../assets/images/proyectos/retratos/retratos_18.jpg";
import retrato_19 from "./../../assets/images/proyectos/retratos/retratos_19.jpg";
import retrato_20 from "./../../assets/images/proyectos/retratos/retratos_20.jpg";
import retrato_21 from "./../../assets/images/proyectos/retratos/retratos_21.jpg";
import retrato_22 from "./../../assets/images/proyectos/retratos/retratos_22.jpg";
import retrato_23 from "./../../assets/images/proyectos/retratos/retratos_23.jpg";
import retrato_24 from "./../../assets/images/proyectos/retratos/retratos_24.jpg";
import retrato_25 from "./../../assets/images/proyectos/retratos/retratos_25.jpg";
import retrato_26 from "./../../assets/images/proyectos/retratos/retratos_26.jpg";
import retrato_27 from "./../../assets/images/proyectos/retratos/retratos_27.jpg";
import retrato_28 from "./../../assets/images/proyectos/retratos/retratos_28.jpg";
import retrato_29 from "./../../assets/images/proyectos/retratos/retratos_29.jpg";
import retrato_30 from "./../../assets/images/proyectos/retratos/retratos_30.jpg";
import retrato_31 from "./../../assets/images/proyectos/retratos/retratos_31.jpg";
import retrato_32 from "./../../assets/images/proyectos/retratos/retratos_32.jpg";
import retrato_33 from "./../../assets/images/proyectos/retratos/retratos_33.jpg";
import retrato_34 from "./../../assets/images/proyectos/retratos/retratos_34.jpg";
import retrato_35 from "./../../assets/images/proyectos/retratos/retratos_35.jpg";
import retrato_36 from "./../../assets/images/proyectos/retratos/retratos_36.jpg";
import retrato_37 from "./../../assets/images/proyectos/retratos/retratos_37.jpg";
import retrato_38 from "./../../assets/images/proyectos/retratos/retratos_38.jpg";
import retrato_39 from "./../../assets/images/proyectos/retratos/retratos_39.jpg";
import retrato_40 from "./../../assets/images/proyectos/retratos/retratos_40.jpg";
import retrato_41 from "./../../assets/images/proyectos/retratos/retratos_41.jpg";
import retrato_42 from "./../../assets/images/proyectos/retratos/retratos_42.jpg";
import retrato_43 from "./../../assets/images/proyectos/retratos/retratos_43.jpg";
import retrato_44 from "./../../assets/images/proyectos/retratos/retratos_44.jpg";
import retrato_45 from "./../../assets/images/proyectos/retratos/retratos_45.jpg";
import retrato_46 from "./../../assets/images/proyectos/retratos/retratos_46.jpg";
import retrato_47 from "./../../assets/images/proyectos/retratos/retratos_47.jpg";
import retrato_48 from "./../../assets/images/proyectos/retratos/retratos_48.jpg";
import retrato_49 from "./../../assets/images/proyectos/retratos/retratos_49.jpg";
import retrato_50 from "./../../assets/images/proyectos/retratos/retratos_50.jpg";
import retrato_51 from "./../../assets/images/proyectos/retratos/retratos_51.jpg";
import retrato_52 from "./../../assets/images/proyectos/retratos/retratos_52.jpg";
import retrato_53 from "./../../assets/images/proyectos/retratos/retratos_53.jpg";
import retrato_54 from "./../../assets/images/proyectos/retratos/retratos_54.jpg";
import retrato_55 from "./../../assets/images/proyectos/retratos/retratos_55.jpg";
import retrato_56 from "./../../assets/images/proyectos/retratos/retratos_56.jpg";
import retrato_57 from "./../../assets/images/proyectos/retratos/retratos_57.jpg";


import pyc_1 from "./../../assets/images/proyectos/pyc/pyc_1.jpg";
import pyc_2 from "./../../assets/images/proyectos/pyc/pyc_2.jpg";
import pyc_3 from "./../../assets/images/proyectos/pyc/pyc_3.jpg";
import pyc_4 from "./../../assets/images/proyectos/pyc/pyc_4.jpg";
import pyc_5 from "./../../assets/images/proyectos/pyc/pyc_5.jpg";
import pyc_6 from "./../../assets/images/proyectos/pyc/pyc_6.jpg";
import pyc_7 from "./../../assets/images/proyectos/pyc/pyc_7.jpg";
import pyc_8 from "./../../assets/images/proyectos/pyc/pyc_8.jpg";
import pyc_9 from "./../../assets/images/proyectos/pyc/pyc_9.jpg";
import pyc_10 from "./../../assets/images/proyectos/pyc/pyc_10.jpg";
import pyc_11 from "./../../assets/images/proyectos/pyc/pyc_11.jpg";
import pyc_12 from "./../../assets/images/proyectos/pyc/pyc_12.jpg";
import pyc_13 from "./../../assets/images/proyectos/pyc/pyc_13.jpg";
import pyc_14 from "./../../assets/images/proyectos/pyc/pyc_14.jpg";
import pyc_15 from "./../../assets/images/proyectos/pyc/pyc_15.jpg";
import pyc_16 from "./../../assets/images/proyectos/pyc/pyc_16.jpg";
import pyc_17 from "./../../assets/images/proyectos/pyc/pyc_17.jpg";
import pyc_18 from "./../../assets/images/proyectos/pyc/pyc_18.jpg";
import pyc_19 from "./../../assets/images/proyectos/pyc/pyc_19.jpg";
import pyc_20 from "./../../assets/images/proyectos/pyc/pyc_20.jpg";
import pyc_21 from "./../../assets/images/proyectos/pyc/pyc_21.jpg";
import pyc_22 from "./../../assets/images/proyectos/pyc/pyc_22.jpg";
import pyc_23 from "./../../assets/images/proyectos/pyc/pyc_23.jpg";
import pyc_24 from "./../../assets/images/proyectos/pyc/pyc_24.jpg";
import pyc_25 from "./../../assets/images/proyectos/pyc/pyc_25.jpg";
import pyc_26 from "./../../assets/images/proyectos/pyc/pyc_26.jpg";
import pyc_27 from "./../../assets/images/proyectos/pyc/pyc_27.jpg";
import pyc_28 from "./../../assets/images/proyectos/pyc/pyc_28.jpg";
import pyc_29 from "./../../assets/images/proyectos/pyc/pyc_29.jpg";
import pyc_30 from "./../../assets/images/proyectos/pyc/pyc_30.jpg";
import pyc_31 from "./../../assets/images/proyectos/pyc/pyc_31.jpg";
import pyc_32 from "./../../assets/images/proyectos/pyc/pyc_32.jpg";
import pyc_33 from "./../../assets/images/proyectos/pyc/pyc_33.jpg";
import pyc_34 from "./../../assets/images/proyectos/pyc/pyc_34.jpg";
import pyc_35 from "./../../assets/images/proyectos/pyc/pyc_35.jpg";
import pyc_36 from "./../../assets/images/proyectos/pyc/pyc_36.jpg";
import pyc_37 from "./../../assets/images/proyectos/pyc/pyc_37.jpg";
import pyc_38 from "./../../assets/images/proyectos/pyc/pyc_38.jpg";
import pyc_39 from "./../../assets/images/proyectos/pyc/pyc_39.jpg";
import pyc_40 from "./../../assets/images/proyectos/pyc/pyc_40.jpg";
import pyc_41 from "./../../assets/images/proyectos/pyc/pyc_41.jpg";
import pyc_42 from "./../../assets/images/proyectos/pyc/pyc_42.jpg";
import pyc_43 from "./../../assets/images/proyectos/pyc/pyc_43.jpg";
import pyc_44 from "./../../assets/images/proyectos/pyc/pyc_44.jpg";
import pyc_45 from "./../../assets/images/proyectos/pyc/pyc_45.jpg";
import pyc_46 from "./../../assets/images/proyectos/pyc/pyc_46.jpg";
import pyc_47 from "./../../assets/images/proyectos/pyc/pyc_47.jpg";
import pyc_48 from "./../../assets/images/proyectos/pyc/pyc_48.jpg";
import pyc_49 from "./../../assets/images/proyectos/pyc/pyc_49.jpg";
import pyc_50 from "./../../assets/images/proyectos/pyc/pyc_50.jpg";
import pyc_51 from "./../../assets/images/proyectos/pyc/pyc_51.jpg";
import pyc_52 from "./../../assets/images/proyectos/pyc/pyc_52.jpg";
import pyc_53 from "./../../assets/images/proyectos/pyc/pyc_53.jpg";
import pyc_54 from "./../../assets/images/proyectos/pyc/pyc_54.jpg";
import pyc_55 from "./../../assets/images/proyectos/pyc/pyc_55.jpg";
import pyc_56 from "./../../assets/images/proyectos/pyc/pyc_56.jpg";
import pyc_57 from "./../../assets/images/proyectos/pyc/pyc_57.jpg";
import pyc_58 from "./../../assets/images/proyectos/pyc/pyc_58.jpg";
import pyc_59 from "./../../assets/images/proyectos/pyc/pyc_59.jpg";
import pyc_60 from "./../../assets/images/proyectos/pyc/pyc_60.jpg";
import pyc_61 from "./../../assets/images/proyectos/pyc/pyc_61.jpg";
import pyc_62 from "./../../assets/images/proyectos/pyc/pyc_62.jpg";
import pyc_63 from "./../../assets/images/proyectos/pyc/pyc_63.jpg";

import publi_1 from "./../../assets/images/proyectos/publicaciones/publi_1.jpg";
import publi_2 from "./../../assets/images/proyectos/publicaciones/publi_2.jpg";
import publi_3 from "./../../assets/images/proyectos/publicaciones/publi_3.jpg";
import publi_4 from "./../../assets/images/proyectos/publicaciones/publi_4.jpg";
import publi_5 from "./../../assets/images/proyectos/publicaciones/publi_5.jpg";
import publi_6 from "./../../assets/images/proyectos/publicaciones/publi_6.jpg";
import publi_7 from "./../../assets/images/proyectos/publicaciones/publi_7.jpg";
import publi_8 from "./../../assets/images/proyectos/publicaciones/publi_8.jpg";
import publi_9 from "./../../assets/images/proyectos/publicaciones/publi_9.jpg";
import publi_10 from "./../../assets/images/proyectos/publicaciones/publi_10.jpg";
import publi_11 from "./../../assets/images/proyectos/publicaciones/publi_11.jpg";
import publi_12 from "./../../assets/images/proyectos/publicaciones/publi_12.jpg";
import publi_13 from "./../../assets/images/proyectos/publicaciones/publi_13.jpg";
import publi_14 from "./../../assets/images/proyectos/publicaciones/publi_14.jpg";
import publi_15 from "./../../assets/images/proyectos/publicaciones/publi_15.jpg";
import publi_16 from "./../../assets/images/proyectos/publicaciones/publi_16.jpg";
import publi_17 from "./../../assets/images/proyectos/publicaciones/publi_17.jpg";
import publi_18 from "./../../assets/images/proyectos/publicaciones/publi_18.jpg";
import publi_19 from "./../../assets/images/proyectos/publicaciones/publi_19.jpg";
import publi_20 from "./../../assets/images/proyectos/publicaciones/publi_20.jpg";
import publi_21 from "./../../assets/images/proyectos/publicaciones/publi_21.jpg";
import publi_22 from "./../../assets/images/proyectos/publicaciones/publi_22.jpg";
import publi_23 from "./../../assets/images/proyectos/publicaciones/publi_23.jpg";
import publi_24 from "./../../assets/images/proyectos/publicaciones/publi_24.jpg";
import publi_25 from "./../../assets/images/proyectos/publicaciones/publi_25.jpg";
import publi_26 from "./../../assets/images/proyectos/publicaciones/publi_26.jpg";
import publi_27 from "./../../assets/images/proyectos/publicaciones/publi_27.jpg";
import publi_28 from "./../../assets/images/proyectos/publicaciones/publi_28.jpg";
import publi_29 from "./../../assets/images/proyectos/publicaciones/publi_29.jpg";
import publi_30 from "./../../assets/images/proyectos/publicaciones/publi_30.jpg";
import publi_31 from "./../../assets/images/proyectos/publicaciones/publi_31.jpg";
import publi_32 from "./../../assets/images/proyectos/publicaciones/publi_32.jpg";
import publi_33 from "./../../assets/images/proyectos/publicaciones/publi_33.jpg";
import publi_34 from "./../../assets/images/proyectos/publicaciones/publi_34.jpg";
import publi_35 from "./../../assets/images/proyectos/publicaciones/publi_35.jpg";
import publi_36 from "./../../assets/images/proyectos/publicaciones/publi_36.jpg";
import publi_37 from "./../../assets/images/proyectos/publicaciones/publi_37.jpg";
import publi_38 from "./../../assets/images/proyectos/publicaciones/publi_38.jpg";
import publi_39 from "./../../assets/images/proyectos/publicaciones/publi_39.jpg";
import publi_40 from "./../../assets/images/proyectos/publicaciones/publi_40.jpg";
import publi_41 from "./../../assets/images/proyectos/publicaciones/publi_41.jpg";
import publi_42 from "./../../assets/images/proyectos/publicaciones/publi_42.jpg";
import publi_43 from "./../../assets/images/proyectos/publicaciones/publi_43.jpg";
import publi_44 from "./../../assets/images/proyectos/publicaciones/publi_44.jpg";
import publi_45 from "./../../assets/images/proyectos/publicaciones/publi_45.jpg";
import publi_46 from "./../../assets/images/proyectos/publicaciones/publi_46.jpg";
import publi_47 from "./../../assets/images/proyectos/publicaciones/publi_47.jpg";
import publi_48 from "./../../assets/images/proyectos/publicaciones/publi_48.jpg";
import publi_49 from "./../../assets/images/proyectos/publicaciones/publi_49.jpg";
import publi_50 from "./../../assets/images/proyectos/publicaciones/publi_50.jpg";
import publi_51 from "./../../assets/images/proyectos/publicaciones/publi_51.jpg";
import publi_52 from "./../../assets/images/proyectos/publicaciones/publi_52.jpg";
import publi_53 from "./../../assets/images/proyectos/publicaciones/publi_53.jpg";
import publi_54 from "./../../assets/images/proyectos/publicaciones/publi_54.jpg";
import publi_55 from "./../../assets/images/proyectos/publicaciones/publi_55.jpg";
import publi_56 from "./../../assets/images/proyectos/publicaciones/publi_56.jpg";
import publi_57 from "./../../assets/images/proyectos/publicaciones/publi_57.jpg";
import publi_58 from "./../../assets/images/proyectos/publicaciones/publi_58.jpg";
import publi_59 from "./../../assets/images/proyectos/publicaciones/publi_59.jpg";
import publi_60 from "./../../assets/images/proyectos/publicaciones/publi_60.jpg";
import publi_61 from "./../../assets/images/proyectos/publicaciones/publi_61.jpg";
import publi_62 from "./../../assets/images/proyectos/publicaciones/publi_62.jpg";
import publi_63 from "./../../assets/images/proyectos/publicaciones/publi_63.jpg";
import publi_64 from "./../../assets/images/proyectos/publicaciones/publi_64.jpg";
import publi_65 from "./../../assets/images/proyectos/publicaciones/publi_65.jpg";
import publi_66 from "./../../assets/images/proyectos/publicaciones/publi_66.jpg";
import publi_67 from "./../../assets/images/proyectos/publicaciones/publi_67.jpg";
import publi_68 from "./../../assets/images/proyectos/publicaciones/publi_68.jpg";
import publi_69 from "./../../assets/images/proyectos/publicaciones/publi_69.jpg";
import publi_70 from "./../../assets/images/proyectos/publicaciones/publi_70.jpg";
import publi_71 from "./../../assets/images/proyectos/publicaciones/publi_71.jpg";
import publi_72 from "./../../assets/images/proyectos/publicaciones/publi_72.jpg";
import publi_73 from "./../../assets/images/proyectos/publicaciones/publi_73.jpg";
import publi_74 from "./../../assets/images/proyectos/publicaciones/publi_74.jpg";
import publi_75 from "./../../assets/images/proyectos/publicaciones/publi_75.jpg";
import publi_76 from "./../../assets/images/proyectos/publicaciones/publi_76.jpg";
import publi_77 from "./../../assets/images/proyectos/publicaciones/publi_77.jpg";
import publi_78 from "./../../assets/images/proyectos/publicaciones/publi_78.jpg";

import publi_79 from "./../../assets/images/proyectos/publicaciones/publi_79.jpg";
import publi_80 from "./../../assets/images/proyectos/publicaciones/publi_80.jpg";
import publi_81 from "./../../assets/images/proyectos/publicaciones/publi_81.jpg";
import publi_82 from "./../../assets/images/proyectos/publicaciones/publi_82.jpg";
import publi_83 from "./../../assets/images/proyectos/publicaciones/publi_83.jpg";
import publi_84 from "./../../assets/images/proyectos/publicaciones/publi_84.jpg";
import publi_85 from "./../../assets/images/proyectos/publicaciones/publi_85.jpg";
import publi_86 from "./../../assets/images/proyectos/publicaciones/publi_86.jpg";

// eslint-disable-next-line import/no-anonymous-default-export
export default [{
    moda: [
        {
            name: moda_1
        },
        {
            name: moda_2
        },
        {
            name: moda_3
        },
        {
            name: moda_4
        },
        {
            name: moda_5
        },
        {
            name: moda_6
        },
        {
            name: moda_7
        },
        {
            name: moda_8
        },
        {
            name: moda_9
        },
        {
            name: moda_10
        },
        {
            name: moda_11
        },
        {
            name: moda_12
        },
        {
            name: moda_13
        },
        {
            name: moda_14
        },
        {
            name: moda_15
        },
        {
            name: moda_16
        },
        {
            name: moda_17
        },
        {
            name: moda_18
        },
        {
            name: moda_19
        },
        {
            name: moda_20
        },
        {
            name: moda_21
        },
        {
            name: moda_22
        },
        {
            name: moda_23
        },
        {
            name: moda_24
        },
        {
            name: moda_25
        },
        {
            name: moda_26
        },
        {
            name: moda_27
        },
        {
            name: moda_28
        },
        {
            name: moda_29
        },
        {
            name: moda_30
        },
        {
            name: moda_31
        },
        {
            name: moda_32
        },
        {
            name: moda_33
        },
        {
            name: moda_34
        },
        {
            name: moda_35
        },
        {
            name: moda_36
        },
        {
            name: moda_37
        },
        {
            name: moda_38
        },
        {
            name: moda_39
        },
        {
            name: moda_40
        },
        {
            name: moda_41
        },
        {
            name: moda_42
        },
        {
            name: moda_43
        },
        {
            name: moda_44
        },
        {
            name: moda_45
        },
        {
            name: moda_46
        },
        {
            name: moda_47
        },
        {
            name: moda_48
        },
        {
            name: moda_49
        },
        {
            name: moda_50
        },
        {
            name: moda_51
        },
        {
            name: moda_52
        },
        {
            name: moda_53
        },
        {
            name: moda_54
        },
        {
            name: moda_55
        },
        {
            name: moda_56
        },
        {
            name: moda_57
        },
        {
            name: moda_58
        },
        {
            name: moda_59
        },
        {
            name: moda_60
        },
        {
            name: moda_61
        },
        {
            name: moda_62
        },
        {
            name: moda_63
        },
        {
            name: moda_64
        },
        {
            name: moda_65
        },
        {
            name: moda_66
        },
        {
            name: moda_67
        },
        {
            name: moda_68
        },
        {
            name: moda_69
        },
        {
            name: moda_70
        },
        {
            name: moda_71
        },
        {
            name: moda_72
        },
        {
            name: moda_73
        },
        {
            name: moda_74
        },
        {
            name: moda_75
        },
        {
            name: moda_76
        },
        {
            name: moda_77
        },
        {
            name: moda_78
        },
        {
            name: moda_79
        },

    ],
    publicaciones: [
        {
            name: publi_1
        },
        {
            name: publi_2
        },
        {
            name: publi_3
        },
        {
            name: publi_4
        },
        {
            name: publi_5
        },
        {
            name: publi_6
        },
        {
            name: publi_7
        },
        {
            name: publi_8
        },
        {
            name: publi_9
        },
        {
            name: publi_10
        },
        {
            name: publi_11
        },
        {
            name: publi_12
        },
        {
            name: publi_13
        },
        {
            name: publi_14
        },
        {
            name: publi_15
        },
        {
            name: publi_16
        },
        {
            name: publi_17
        },
        {
            name: publi_18
        },
        {
            name: publi_19
        },
        {
            name: publi_20
        },
        {
            name: publi_21
        },
        {
            name: publi_22
        },
        {
            name: publi_23
        },
        {
            name: publi_24
        },
        {
            name: publi_25
        },
        {
            name: publi_26
        },
        {
            name: publi_27
        },
        {
            name: publi_28
        },
        {
            name: publi_29
        },
        {
            name: publi_30
        },
        {
            name: publi_31
        },
        {
            name: publi_32
        },
        {
            name: publi_33
        },
        {
            name: publi_34
        },
        {
            name: publi_35
        },
        {
            name: publi_36
        },
        {
            name: publi_37
        },
        {
            name: publi_38
        },
        {
            name: publi_39
        },
        {
            name: publi_40
        },
        {
            name: publi_41
        },
        {
            name: publi_42
        },
        {
            name: publi_43
        },
        {
            name: publi_44
        },
        {
            name: publi_45
        },
        {
            name: publi_46
        },
        {
            name: publi_47
        },
        {
            name: publi_48
        },
        {
            name: publi_49
        },
        {
            name: publi_50
        },
        {
            name: publi_51
        },
        {
            name: publi_52
        },
        {
            name: publi_53
        },
        {
            name: publi_54
        },
        {
            name: publi_55
        },
        {
            name: publi_56
        },
        {
            name: publi_57
        },
        {
            name: publi_58
        },
        {
            name: publi_59
        },
        {
            name: publi_60
        },
        {
            name: publi_61
        },
        {
            name: publi_62
        },
        {
            name: publi_63
        },
        {
            name: publi_64
        },
        {
            name: publi_65
        },
        {
            name: publi_66
        },
        {
            name: publi_67
        },
        {
            name: publi_68
        },
        {
            name: publi_69
        },
        {
            name: publi_70
        },
        {
            name: publi_71
        },
        {
            name: publi_72
        },
        {
            name: publi_73
        },
        {
            name: publi_74
        },
        {
            name: publi_75
        },
        {
            name: publi_76
        },
        {
            name: publi_77
        },
        {
            name: publi_78
        },
        {
            name: publi_79
        },
        {
            name: publi_80
        },
        {
            name: publi_81
        },
        {
            name: publi_82
        },
        {
            name: publi_83
        },
        {
            name: publi_84
        },
        {
            name: publi_85
        },
        {
            name: publi_86
        },
    ],
    'productos-y-comida': [
        {
            name: pyc_1
        },
        {
            name: pyc_2
        },
        {
            name: pyc_3
        },
        {
            name: pyc_4
        },
        {
            name: pyc_5
        },
        {
            name: pyc_6
        },
        {
            name: pyc_7
        },
        {
            name: pyc_8
        },
        {
            name: pyc_9
        },
        {
            name: pyc_10
        },
        {
            name: pyc_11
        },
        {
            name: pyc_12
        },
        {
            name: pyc_13
        },
        {
            name: pyc_14
        },
        {
            name: pyc_15
        },
        {
            name: pyc_16
        },
        {
            name: pyc_17
        },
        {
            name: pyc_18
        },
        {
            name: pyc_19
        },
        {
            name: pyc_20
        },
        {
            name: pyc_21
        },
        {
            name: pyc_22
        },
        {
            name: pyc_23
        },
        {
            name: pyc_24
        },
        {
            name: pyc_25
        },
        {
            name: pyc_26
        },
        {
            name: pyc_27
        },
        {
            name: pyc_28
        },
        {
            name: pyc_29
        },
        {
            name: pyc_30
        },
        {
            name: pyc_31
        },
        {
            name: pyc_32
        },
        {
            name: pyc_33
        },
        {
            name: pyc_34
        },
        {
            name: pyc_35
        },
        {
            name: pyc_36
        },
        {
            name: pyc_37
        },
        {
            name: pyc_38
        },
        {
            name: pyc_39
        },
        {
            name: pyc_40
        },
        {
            name: pyc_41
        },
        {
            name: pyc_42
        },
        {
            name: pyc_43
        },
        {
            name: pyc_44
        },
        {
            name: pyc_45
        },
        {
            name: pyc_46
        },
        {
            name: pyc_47
        },
        {
            name: pyc_48
        },
        {
            name: pyc_49
        },
        {
            name: pyc_50
        },
        {
            name: pyc_51
        },
        {
            name: pyc_52
        },
        {
            name: pyc_53
        },
        {
            name: pyc_54
        },
        {
            name: pyc_55
        },
        {
            name: pyc_56
        },
        {
            name: pyc_57
        },
        {
            name: pyc_58
        },
        {
            name: pyc_59
        },
        {
            name: pyc_60
        },
        {
            name: pyc_61
        },
        {
            name: pyc_62
        },
        {
            name: pyc_63
        },
    ],
    retratos: [
        {
            name: retrato_1
        },
        {
            name: retrato_2
        },
        {
            name: retrato_3
        },
        {
            name: retrato_4
        },
        {
            name: retrato_5
        },
        {
            name: retrato_6
        },
        {
            name: retrato_7
        },
        {
            name: retrato_8
        },
        {
            name: retrato_9
        },
        {
            name: retrato_10
        },
        {
            name: retrato_11
        },
        {
            name: retrato_12
        },
        {
            name: retrato_13
        },
        {
            name: retrato_14
        },
        {
            name: retrato_15
        },
        {
            name: retrato_16
        },
        {
            name: retrato_17
        },
        {
            name: retrato_18
        },
        {
            name: retrato_19
        },
        {
            name: retrato_20
        },
        {
            name: retrato_21
        },
        {
            name: retrato_22
        },
        {
            name: retrato_23
        },
        {
            name: retrato_24
        },
        {
            name: retrato_25
        },
        {
            name: retrato_26
        },
        {
            name: retrato_27
        },
        {
            name: retrato_28
        },
        {
            name: retrato_29
        },
        {
            name: retrato_30
        },
        {
            name: retrato_31
        },
        {
            name: retrato_32
        },
        {
            name: retrato_33
        },
        {
            name: retrato_34
        },
        {
            name: retrato_35
        },
        {
            name: retrato_36
        },
        {
            name: retrato_37
        },
        {
            name: retrato_38
        },
        {
            name: retrato_39
        },
        {
            name: retrato_40
        },
        {
            name: retrato_41
        },
        {
            name: retrato_42
        },
        {
            name: retrato_43
        },
        {
            name: retrato_44
        },
        {
            name: retrato_45
        },
        {
            name: retrato_46
        },
        {
            name: retrato_47
        },
        {
            name: retrato_48
        },
        {
            name: retrato_49
        },
        {
            name: retrato_50
        },
        {
            name: retrato_51
        },
        {
            name: retrato_52
        },
        {
            name: retrato_53
        },
        {
            name: retrato_54
        },
        {
            name: retrato_55
        },
        {
            name: retrato_56
        },
        {
            name: retrato_57
        },
    ]
}]